module.exports = __webpack_public_path__ + "img/tick.987a8229.png";